export default __webpack_public_path__ + "static/media/fc_icon_good_active.268e0a65.svg";